module.exports = __webpack_public_path__ + "static/media/telegram.28146bd8.svg";